<template>
  <div class="ba-container ba-gp-1 ba-ai-baseline ba-w-100 ba-grid">
    <Breadcrumbs />
    <!-- <nav-component :items="false" :newSite="false" :newSiteModal="false">
      <template #content></template>
    </nav-component> -->

    <!-- <save-website-component  :type="'connect'" :action="'connect'"></save-website-component> -->

    <FirstWebsite />
  </div>
</template>

<script>
import FirstWebsite from "./FirstWebsite";
import Breadcrumbs from "../general/Breadcrumbs.vue";
// import NavComponent from './layout/nav/Nav.vue';

export default {
  name: "CreateSite",
  components: {
    FirstWebsite,
    Breadcrumbs
  }
};
</script>

<style lang="scss" scoped>
.ba-container {
  max-width: unset !important;
}

.container-dashboard {
  overflow: hidden;
}

.button-tag {
  height: 40px;
  margin-top: 3px !important;
  text-transform: uppercase;
}

.container-box {
  padding: 0 40px;
}

.dropdown-menu {
  right: 0;
  left: auto;
}

.box {
  width: 23%;
}

.new-website {
  background: #f8fafd 0% 0% no-repeat padding-box;
  border: 1px dashed #05c1fc;
  cursor: pointer;
}

.new-website .btn:hover {
  color: #0056b3;
}

.box-website {
  // border: 1px solid salmon;
}

.box-info {
  display: flex;
  flex-direction: column;
  text-align: center;
}

@media (max-width: 575.98px) {
  .box {
    max-width: 94%;
    min-width: 300px;
    margin: 15px 3%;
  }
}

@media (min-width: 576px) and (max-width: 767.98px) {
  .box {
    max-width: 90%;
    min-width: 300px;
    margin: 15px 5%;
  }
}

@media (min-width: 768px) and (max-width: 1049.99px) {
  .box {
    max-width: 46%;
    min-width: 300px;
    margin: 15px 2%;
  }
  .btn-add-tag {
    font-size: 10px !important;
    margin-right: 30px !important;
  }
}

@media (min-width: 1050px) and (max-width: 1299.98px) {
  .box {
    max-width: 31.33%;
    min-width: 31.33%;
    margin: 15px 1%;
  }
}

@media (min-width: 1300px) {
  .box {
    min-width: 31.33%;
    max-width: 31.33%;
    margin: 0 1% 15px 1%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/DashboardCreateSite.vue